import { Color } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { UserAvailability } from 'dashboard/models/user';

export const AVAILABILITY_COLOR_MAP: Record<UserAvailability, Color | 'transparent'> = {
  [UserAvailability.Available]: Color.CoreGreen800,
  [UserAvailability.Busy]: Color.CoreYellow800,
  [UserAvailability.Unavailable]: 'transparent',
};

const AvailabilityCircle = styled('div')<{ availability: UserAvailability }>`
  position: relative;
  width: 10px;
  height: 10px;
  background-color: ${({ availability }) => AVAILABILITY_COLOR_MAP[availability]};
  border: ${({ availability }) =>
    availability === UserAvailability.Unavailable ? `2px solid ${Color.CoreSlate500}` : 'none'};
  border-radius: 50%;
`;

export default AvailabilityCircle;
